/**
 * Notifications mixin
 */

export default {
  methods: {
    /**
     * Show notification
     * @param type {String}: success|info|warning|error
     * @param message {String}
     */
    showNotification({ type, message }) {
      if (!message) {
        return;
      }

      this.$notify(
        Object.assign(
          {
            type: type || "success",
            message: message,
            hideIcon: true,
            top: true,
            showClose: true,
            closeDelay: 7000
          },
          this.$store.state.event.config.defaultNotificationConfig
        )
      );
    }
  }
};
